import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { inject, observer } from "mobx-react";
import GameInfo from '../game/gameInfo'
import SubmitLimitTip from './submitLimitTip'
import { Spin } from 'antd'
import Language from '../language/language'
import { $const } from '../../helper'

import './stylesheets/gameApplyInfo.scss'

@inject('teamStore', 'authStore', 'gameStore', 'languageStore', 'personGameStore')
@withRouter
@observer
export default class GameApplyPerson extends React.Component {
  state = {
    isLoading: false
  }
  componentWillMount () {
    // 防止</GameInfo>重复渲染，每次进来前清空数据
    this.props.personGameStore.resetInfo()
    this.props.teamStore.resetQuiz()
    this.props.teamStore.resetStageMap()
  }
  componentDidMount () {
    this.setState({
      isLoading: true
    })
    this.props.personGameStore.getGameInfo(this.props.match.params.id).finally(() => {
      this.setState({
        isLoading: false
      })
    })
  }
  submitLimitForm = () => {
    this.props.gameStore.formSubmit().then(() => {
      this.props.personGameStore.getGameInfo(this.props.match.params.id)
    }).finally(() => {
      this.closeSubmitLimitModal()
      this.props.gameStore.submitButtonStateLoading()
      setTimeout(() => {
        this.props.gameStore.submitButtonStateNormal()
      }, 3000);
    })
  }

  closeSubmitLimitModal = () => {
    this.props.gameStore.clearSubmitLimit()
  }

  render () {
    const gameData = this.props.personGameStore.info
    if (!gameData || !gameData.id || !this.props.authStore.user.id) {
      return <div className="game-apply-info"></div>
    }
    if (this.state.isLoading) {
      return (
        <div className="game-apply-info empty">
          <Spin />
        </div>
      )
    }
    const gameInfo = gameData.myFlow
    const lang = this.props.languageStore.lang
    let stageIdMajorNum = 0
    gameInfo && gameInfo.stages && gameInfo.stages.nodes.forEach(node => {
      if (node.id === gameData.stageId) {
        stageIdMajorNum = node.majorNum
      }
    });
    return (
      <div className="game-apply-info person" data-perf>
        <div className="game-name title">
          { gameData.event && gameData.event.titleUuidI18n && gameData.event.titleUuidI18n[lang]}
        </div>
        <GameInfo gameType={$const.SOURCE_TYPE.PERSON} canSubmit={true} stageIdMajorNum={stageIdMajorNum} stageId={gameData.stageId} gameData={gameData} gameInfo={gameInfo} />
        {this.props.gameStore.submitLimit
          ?
            <SubmitLimitTip  submit={this.submitLimitForm}  close={this.closeSubmitLimitModal} />
          : null
        }
        <div className="operate">
          <Link className="back-control-center"
              to="/control-center"
            >
            <Language resource="RETURN_CONTROL_CENTER" />
          </Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/controlCenter/gameApplyPerson.js